<template>
    <div v-if="primary_data">
        <v-form ref="primary_data" v-model="valid">
        <v-container>
        <v-row no-gutters>
            <v-col cols="6">
                <v-autocomplete dense outlined
                :disabled="owner_lock"
                :items="orgs"
                v-model="owner"
                required
                label="ente proprietario"
                item-text="value.name"
                item-value="id"
                :rules="[rules.mandatory]"
                />
            </v-col>
            <v-col cols="6" class="pl-2">
                <v-autocomplete dense outlined
                :disabled="owner_lock"
                :items="orgs"
                v-model="used_by"
                label="in uso presso"
                item-text="value.name"
                item-value="id"
                @change="changeUsed_by"
                :rules="[rules.mandatory]"
                />
            </v-col>
        </v-row>
        <v-row class="no-gutters" v-if="show_note">
            <v-col cols="6" class="offset-6 pl-2" >
                <v-textarea dense outlined
                    label="note prestito/restituzione"
                    v-model="note"
                    rows="2"
                />
            </v-col>
        </v-row>
        <v-row class="no-gutters my-2" v-if="owner">
            
            <v-col cols="8">
                <v-progress-linear
                    v-if="uploading"
                    color="primary"
                    indeterminate
                    rounded
                    height="6"
                ></v-progress-linear>
                
                <a v-if="primary_data.certificate_ref" :href="getCertPath()+''+primary_data.certificate_ref" target="_blank">
                    <v-icon class="pr-2">get_app</v-icon>
                    <span v-if="primary_data.certificate_name">{{primary_data.certificate_name}}</span>
                    <span v-else> certificato</span>
                </a>
                <span v-else class="error--text">*certificato obbligatorio</span>
            </v-col>
            <v-col cols="4" class="d-flex justify-end">
                <VueUploadComponent
                    ref="upload"
                    v-model="files"
                    input-id="file1"
                    class="btn"
                    accept="application/pdf"
                    @input-file="inputFile"
                    @input-filter="inputFilter"
                    >
                    <v-btn :disabled="$store.state.offline" elevation-2 color="primary" class="my-2">
                        <span class="pr-1" v-if="primary_data.certificate_ref">aggiorna</span><span class="pr-1" v-else>carica</span> certificato
                    </v-btn>
                </VueUploadComponent>
            </v-col>
            <v-col cols="12">
                <v-alert type="error" :value="failed">
                    errore durante il caricamento del file
                </v-alert>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="6">
                <v-text-field dense outlined
                v-model="primary_data.certificate_nr"
                label="certificato numero*"
                required
                :rules="[rules.mandatory]"
                />
            </v-col>
            <v-col cols="6" class="pl-2">
                <v-text-field dense outlined
                v-model="primary_data.certificate_authority"
                label="autorità certificante*"
                :rules="[rules.mandatory]"
                required
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="4">
                <NumericField dense outlined 
                v-model="primary_data.validity"
                label="mesi validità*"
                :precision="0"
                :rules="[rules.mandatory]"
                @blur="updateExpire" 
                />
            </v-col>
            <v-col cols="4" class="pl-2">
                <CalendarField
                    v-model="primary_data.emission"
                    :rules="[rules.mandatory]"
                    label="data ultima certificazione*"
                    @input="updateExpire"
                >
                </CalendarField>    
                </v-col>
                <v-col cols="4" class="pl-2">
                    <CalendarField
                        v-model="primary_data.expire"
                        :minDate="primary_data.emission"
                        :rules="[rules.mandatory]"
                        label="scadenza*"
                    ></CalendarField>
                </v-col>
            </v-row>
            <v-row class="no-gutters my-2" v-if="owner && primary_data.certificate_ref">
            <v-col cols="6">
                <v-progress-linear
                    v-if="intermediate_uploading"
                    color="primary"
                    indeterminate
                    rounded
                    height="6"
                ></v-progress-linear>
                
                <a v-if="primary_data.intermediate_certificate_ref" :href="getCertPath()+''+primary_data.intermediate_certificate_ref" target="_blank">
                    <v-icon class="pr-2">get_app</v-icon>
                    <span v-if="primary_data.intermediate_certificate_name">{{primary_data.intermediate_certificate_name}}</span>
                    <span v-else> certificato</span>
                </a>
            </v-col>
            <v-col cols="2" class="pl-2" >
                <v-checkbox v-if="primary_data.intermediate_certificate_ref" class="ma-0" hide-details v-model="primary_data.active" label="Strumento conforme"></v-checkbox>
            </v-col>
            <v-col cols="4" class="d-flex justify-end">
                <VueUploadComponent
                    ref="intermediate_upload"
                    v-model="intermediate_files"
                    input-id="int_file1"
                    class="btn"
                    accept="application/pdf"
                    @input-file="intermediateinputFile"
                    @input-filter="inputFilter"
                    >
                    <v-btn :disabled="$store.state.offline" elevation-2 color="primary" class="my-2">
                        <span class="pr-1" v-if="primary_data.intermediate_certificate_ref">aggiorna</span><span class="pr-1" v-else>carica</span> certificato intermedio
                    </v-btn>
                </VueUploadComponent>
            </v-col>
            <v-col cols="12">
                <v-alert type="error" :value="intermediate_failed">
                    errore durante il caricamento del file intermedio
                </v-alert>
            </v-col>
        </v-row>
            <div v-if="primary_data.intermediate_certificate_ref">
            <v-row no-gutters>
                <v-col cols="6">
                    <v-text-field dense outlined
                    v-model="primary_data.intermediate_certificate_nr"
                    label="certificato numero*"
                    required
                    :rules="[rules.mandatory]"
                    />
                </v-col>
                <v-col cols="6" class="pl-2">
                    <v-text-field dense outlined
                    v-model="primary_data.intermediate_certificate_authority"
                    label="autorità certificante*"
                    :rules="[rules.mandatory]"
                    required
                    />
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="4">
                    <NumericField dense outlined 
                    v-model="primary_data.intermediate_validity"
                    label="mesi validità*"
                    :precision="0"
                    :rules="[rules.mandatory]"
                    @blur="intermediateUpdateExpire" 
                    />
                </v-col>
                <v-col cols="4" class="pl-2">
                    <CalendarField
                        v-model="primary_data.intermediate_emission"
                        :rules="[rules.mandatory]"
                        label="data ultima certificazione*"
                        @input="intermediateUpdateExpire"
                    >
                    </CalendarField>    
                    </v-col>
                    <v-col cols="4" class="pl-2">
                        <CalendarField
                            v-model="primary_data.intermediate_expire"
                            :minDate="primary_data.intermediate_emission"
                            :rules="[rules.mandatory]"
                            label="scadenza*"
                        ></CalendarField>
                    </v-col>
                    
            </v-row>
            </div>
            <v-row no-gutter>
                <v-col cols="12" class="d-flex align-start justify-start flex-grow-1 flex-shrink-0 font-weight-bold font-italic">
                    Range di funzionamento
                </v-col>        
            
                <v-col cols="12" class="d-flex flex-row align-start flex-grow-1 flex-shrink-0">
                    <v-autocomplete dense outlined
                        ref="UOMS"
                        label="unità di misura"
                        :items="pr_families[family].uoms"
                        item-value="id"
                        v-model="primary_data.uom">
                    </v-autocomplete>
                    <NumericField dense outlined
                        label="da"
                        class="pl-2"
                        v-model="primary_data.min_use"
                        :max="primary_data.max_use"
                        :negative="isNegativeValue()"
                        :suffix="primary_data.uom"
                        placeholder="0"
                    ></NumericField>    
                    <NumericField dense outlined
                        class="pl-2"
                        label="a"
                        v-model="primary_data.max_use"
                        :min="primary_data.min_use"
                        :negative="isNegativeValue()"
                        :suffix="primary_data.uom"
                        placeholder="0"
                    ></NumericField>       
                </v-col>
            </v-row>
        </v-container>
    </v-form>
     <div v-if="family != null">
        <dynamiclink
        ref="blockData"
        :data="buildData"
        v-on:autoUpdate="addSpecificData"
        v-on:validitySpecific="validateSpecific"
        />
    </div>
</div>
</template>

<script>
import dynamiclink from "../../../components/utils/Instrument_d_link"
import VueUploadComponent from "vue-upload-component";
import {getModel} from '../../../utils/model'
import {p_families} from "../../../utils/common"
import { f_rules, getCertificatePath } from '../../../utils/commonUtils';
import { searchDesign, orderByFields } from '../../../utils/dbUtility';
export default {
    components: {VueUploadComponent, dynamiclink},
    props: {
        org_id: {
            type: String,
            required: false,
            default: null
        },
        o_used_by: {
            type: String,
            required: false,
            default: null
        },
        owner_lock:{
            type: Boolean,
            required: false,
            default: false
        },
        family: {
            type: String,
            required: false,
            default: null
        },
        instrument_id:{
            type: String,
            required: false,
            default: ''
        },
        o_primary_data: {
            type: Object,
            required: false,
            default: null
        }
    },
    data() {
        return {
            valid: false,
            validity_specific: false,  // if dynamic link is valid

            period: "12",
            pr_families: p_families,
            owner: this.org_id,
            used_by: this.o_used_by ? this.o_used_by : this.org_id,
            orgs: null,
            files: [],
            intermediate_files: [],
            primary_data: null,
            rules: f_rules,
            cur_family: null,
            show_note: false,
            uploading: false,
            failed: false,
            intermediate_uploading: false,
            intermediate_failed: false,
            note: ""
        }
    },
    watch: {
        'valid':{
            handler() {
                console.log("primary data validity", this.valid)
                this.$emit('primary_validity', this.isValid)
            }
        },
        'validity_specific': {
            handler() {
                console.log("dynamic link validity", this.valid)
                this.$emit('primary_validity', this.isValid)
            }
        },
        'family': {
            handler(){
                console.log("family changed", this.family)
                this.buildFamily()
            }
        },
        'primary_data.certificate_ref': {
            handler(){
                console.log("file selected", this.primary_data.certificate_ref)
                this.$emit('primary_validity', this.isValid)
            }
        },
        'owner': {
            handler() {
                if (!this.used_by) {
                    this.used_by = this.owner
                }
            }
        }
    },
    methods: {
        async intermediateinputFile(){
            this.intermediate_uploading = true;
            this.intermediate_failed = false;
            this.primary_data.intermediate_certificate_ref = null
            console.log("file selected", this.intermediate_files[0].file)
            let uuidv1 = require('uuid/v1')
            let name = uuidv1()+".pdf"
            let form = new window.FormData()
            form.append('file', this.intermediate_files[0].file)
            let res = await this.axios.post(
                "/mastercal/instruments/files", form, 
                {
                    headers: {"Content-Type": "multipart/formdata"},
                    params: {org_id: this.owner, instr_id: this.instrument_id, file_name: name}
                }).catch(error => {
                    if(error){
                        console.log(error)
                        this.intermediate_uploading = false;
                        this.failed = true;
                    }
                })
            console.log("result axios intermediate", res)
            if(res && res.status == 200){
                console.log("confirmed update", res)
                this.primary_data.intermediate_certificate_name = this.intermediate_files[0].file.name
                this.primary_data.intermediate_certificate_ref = res.data 
                this.intermediate_uploading = false;
            }
        },
        
        async inputFile(){
            this.uploading = true;
            this.failed = false;
            this.primary_data.certificate_ref = null
            console.log("file selected", this.files[0].file)
            let uuidv1 = require('uuid/v1')
            let name = uuidv1()+".pdf"
            let form = new window.FormData()
            form.append('file', this.files[0].file)
            let res = await this.axios.post(
                "/mastercal/instruments/files", form, 
                {
                    headers: {"Content-Type": "multipart/formdata"},
                    params: {org_id: this.owner, instr_id: this.instrument_id, file_name: name}
                }).catch(error => {
                    if(error){
                        console.log(error)
                        this.uploading = false;
                        this.failed = true;
                    }
                })
            console.log("result axios", res)
            if(res && res.status == 200){
                console.log("confirmed update", res)
                this.primary_data.certificate_name = this.files[0].file.name
                this.primary_data.certificate_ref = res.data 
                this.uploading = false;
            }
        },
        getCertPath() {
            return getCertificatePath()
        },
        changeUsed_by() {
            if (this.used_by != this.o_used_by && this.used_by!=this.owner) {
                this.show_note = true
                this.note = ""
            } else if (this.used_by != this.o_used_by && this.used_by==this.owner) {
                this.show_note = true
                this.note = ""
            } else {
                this.show_note = false
                this.note = ""
            }
        },
        upload(){
            this.files[0].data = {
                owner_id: this.$store.state.user.organization_id,
                filename: this.files[0].name
            }
            this.$refs.upload.active = true;
        },
        updateExpire() {
            console.log('update expire')
            let val_period = parseInt(this.primary_data.validity)
            if (this.primary_data.emission > 0 && val_period > 0) {
                let d = new Date(this.primary_data.emission)
                console.log(d)
                this.primary_data.expire = d.setMonth(d.getMonth() + val_period)
            } 
        },
        intermediateUpdateExpire() {
            console.log('update expire')
            let val_period = parseInt(this.primary_data.intermediate_validity)
            if (this.primary_data.emission > 0 && val_period > 0) {
                let d = new Date(this.primary_data.intermediate_emission)
                console.log(d)
                this.primary_data.intermediate_expire = d.setMonth(d.getMonth() + val_period)
            } 
        },
        validateSpecific(valid){
            this.validity_specific = valid
        },
        addSpecificData(data){
            this.primary_data.data = JSON.parse(JSON.stringify(data))
        },
        getData(){
            console.log("requested data")
            this.primary_data.data = this.$refs.blockData.getData()
            return this.primary_data
        },
        isNegativeValue(){
            return p_families[this.family].negativeMin
        },
        initData(){
            if (_.isEmpty(this.o_primary_data)) {
                let PrimaryData = getModel('PrimaryData')
                this.primary_data = PrimaryData()
                console.log(" NEW PRIMARY DATA " ,this.primary_data)
            } else {
                this.primary_data = _.cloneDeep(this.o_primary_data)
                console.log('PRIMARY DATA CLONED', this.primary_data)
            }
            this.$nextTick(()=>{
                this.$refs.primary_data.validate()
            })
            //this.$refs.primary_data.validate()
            console.log("init primary data", this.primary_data)
        },
        buildFamily(){
            this.cur_family = p_families[this.family]
            console.log("family changed curfamily", this.cur_family)
        },
        
        inputFilter: function (newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                // Filter non-pdf file
                if (!/\.(pdf)$/i.test(newFile.name)) {
                console.log("filtered non pdf file")
                return prevent()
                }
            }
        },
    },
    async mounted() {
        let res = await searchDesign(this.$store.state.$pouch, 'registry', 'registry/searchByData', 'key', "organism", false)
        this.orgs = orderByFields(res, {value: ['value.name'], order: ['asc']})   
        this.buildFamily()
        this.initData()

    },
    computed: {
        buildData(){
            let item = {block: this.cur_family, instrument: this.instrument_id, p_data: this.primary_data.data}
            return item
        },
        isValid(){
            return this.valid && this.validity_specific && !!this.primary_data.certificate_ref
        }
    }
}
</script>

<style>

</style>